import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-foreground text-white hover:bg-foreground/85 active:bg-foreground/80 shadow-sm",
        primary:
          "bg-primary text-white hover:bg-primary/90 active:bg-primary/85 shadow-sm",
        destructive:
          "bg-destructive text-white shadow-sm hover:bg-destructive/90",
        outline:
          "border-2 border-foreground/20 bg-transparent text-foreground hover:bg-foreground/5 hover:border-foreground/30 active:bg-foreground/10",
        secondary:
          "bg-secondary text-foreground hover:bg-secondary/80 active:bg-secondary/70",
        ghost: 
          "text-foreground hover:bg-secondary active:bg-secondary/80",
        link: 
          "text-primary underline-offset-4 hover:underline",
        // Special variant for dark backgrounds (CTA section)
        "outline-dark":
          "border-2 border-white/30 bg-transparent text-white hover:bg-white/10 hover:border-white/50 active:bg-white/15",
        "primary-light":
          "bg-white text-foreground hover:bg-white/90 active:bg-white/85 shadow-lg",
      },
      size: {
        default: "h-11 px-5 py-2.5",
        sm: "h-9 px-4 text-xs",
        lg: "h-12 px-6 text-base",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      data-testid={props['data-testid']}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }